import React, { Component } from 'react';
import { message } from 'antd';

import { querySaveApportion } from '@api/finance/apportion';

import FormBase from './FormBase';

class Page extends Component {
  constructor(props) {
    super(props);
    this.state = {
      dataInfo: {},
    };
  }

  componentDidMount() {}

  /**
   * 提交报销
   */
  handSubmit = item => {
    querySaveApportion(item).then(res => {
      if (res.statusCode === 200) {
        message.success(res.message);
        this.props.router.go(-1);
      } else {
        message.error(res.message);
      }
    });
  };

  render() {
    const { dataInfo } = this.state;
    return (
      <div>
        <FormBase data={this.state.dataInfo} handSubmit={this.handSubmit} dataInfo={dataInfo} />
      </div>
    );
  }
}

export default Page;



// WEBPACK FOOTER //
// ./src/components/finance/apportion/PageAdd.js